import { ChangeDetectorRef, Directive, ElementRef, Input, SimpleChanges } from '@angular/core';

@Directive({
  selector: '[prgovAppTriggerChangeDetection]'
})
export class AppTriggerChangeDetectionDirective {
  @Input() appTriggerChangeDetection: any;

  constructor(private el: ElementRef, private cdr: ChangeDetectorRef) {
    console.log(this.appTriggerChangeDetection)
  }

  ngOnChanges(changes: SimpleChanges): void {
    console.log('appTriggerChangeDetection', changes['appTriggerChangeDetection']);
    if (changes['appTriggerChangeDetection']) {
      this.cdr.detectChanges();
    }
  }
}
